<template>
  <v-container>
    <div class="d-flex justify-end mb-4">
      <v-btn
        variant="elevated"
        color="blue"
        rounded="lg"
        prepend-icon="mdi-plus-box"
        @click="openFolderDialog"
      >
        Añadir Carpeta
      </v-btn>
    </div>
    <v-card class="pa-3">
      <v-card-title class="bg-blue-darken-2 text-white d-flex justify-space-between align-center">
        <div>
          <v-icon start>mdi-folder-open</v-icon>
          Gestión de Archivos
        </div>
        <v-btn
          color="white"
          variant="flat"
          prepend-icon="mdi-upload"
          @click="opendialogUpload"
        >
          Subir archivo
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="files"
        :group-by="groupBy"
        :loading="loading"
        :row-props="fileRowProps"
        class="elevation-1"
      >
        <template #group-header="{ item, columns, toggleGroup, isGroupOpen }">
          <tr>
            <td :colspan="columns.length">
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center">
                  <v-btn
                    icon
                    size="small"
                    variant="text"
                    @click="toggleGroup(item)"
                  >
                    <v-icon>
                      {{ isGroupOpen(item) ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                    </v-icon>
                  </v-btn>

                  <v-icon class="mr-2" color="amber-darken-2">mdi-folder</v-icon>
                  <strong>{{ item.value }}</strong>
                  <v-btn
                    v-if="item.value !== 'Raíz'"
                    icon
                    size="small"
                    color="purple"
                    variant="text"
                    class="ml-2"
                    @click="openFolderPermissions(item)"
                    title="Permisos carpeta"
                  >
                    <v-icon>mdi-account-lock</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="item.value !== 'Raíz'"
                    icon
                    size="small"
                    color="indigo"
                    variant="text"
                    class="ml-1"
                    @click="openViewFolderPermissions(item)"
                    title="Ver permisos vigentes"
                  >
                    <v-icon>mdi-account-eye</v-icon>
                  </v-btn>

                  <v-btn
                    v-if="canDeleteFolder(item)"
                    icon
                    size="small"
                    color="red"
                    variant="text"
                    class="ml-1"
                    @click="deleteFolder(item)"
                    title="Eliminar carpeta"
                  >
                    <v-icon>mdi-folder-remove</v-icon>
                  </v-btn>
                </div>

                <span class="text-medium-emphasis">
                  {{ countFiles(item.items) }} archivo(s)
                </span>
              </div>
            </td>
          </tr>
        </template>

        <template #item.file_name="{ item }">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-file-document</v-icon>
            {{ item.file_name }}
          </div>
        </template>

        <template #item.vigente="{ item }">
          <v-chip
            :color="item.vigente ? 'green' : 'red'"
            class="text-white"
            size="small"
            @click="toggleVigente(item)"
            style="cursor:pointer"
          >
            {{ item.vigente ? 'Vigente' : 'No vigente' }}
          </v-chip>
        </template>

        <template #item.actions="{ item }">
          
          <v-btn
            icon
            color="blue"
            :href="resolveFileUrl(item.file_content)"
            target="_blank"
            title="Abrir"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>

          <v-btn
            icon
            color="purple"
            @click="openPermissionsDialog(item, 'file')"
            title="Gestionar permisos"
          >
            <v-icon>mdi-account-lock</v-icon>
          </v-btn>

          <v-btn
            icon
            color="indigo"
            @click="openViewPermissionsDialog(item, 'file')"
            title="Ver permisos vigentes"
          >
            <v-icon>mdi-account-eye</v-icon>
          </v-btn>

          <v-btn
            icon
            color="red"
            @click="deleteFile(item.id_file)"
            title="Eliminar"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>

      <!-- Back to Panel -->
      <div class="text-center mt-6 mb-6">
        <v-btn
          to="/admin"
          variant="text"
          color="grey-darken-1"
          prepend-icon="mdi-arrow-left"
        >
          Volver al Panel
        </v-btn>
      </div>
    </v-card>

    <!-- Modal Folder -->
    <v-dialog v-model="Folderdialog" max-width="600px">
      <v-card>
        <v-card-title class="bg-orange text-white">
          <span class="text-h5">Agregar Carpeta</span>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="formData.folder_name"
              label="Nombre de la Carpeta"
              variant="outlined"
              class="mb-4"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" variant="text" @click="closeDialog">
            Cancelar
          </v-btn>
          <v-btn color="indigo" variant="flat" @click="saveFolder" :disabled="!valid">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL -->
    <v-dialog v-model="dialogUpload" max-width="500">
      <v-card rounded="lg">
        <v-card-title class="bg-blue-darken-2 text-white">
          <v-icon start>mdi-upload</v-icon>
          Cargar archivo
        </v-card-title>

        <v-card-text class="pt-4">
          <v-form ref="formRef">
            <!-- Carpeta -->
            <v-select
              v-model="selectedFolder"
              :items="folderOptions"
              item-title="label"
              item-value="value"
              label="Carpeta destino"
              variant="outlined"
              class="mb-4"
            />

            <!-- Archivo -->
            <v-file-input
              v-model="selectedFile"
              label="Seleccionar archivo"
              prepend-icon="mdi-paperclip"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              :multiple="false"
              show-size
              clearable
              :rules="[fileRule]"
              @update:modelValue="normalizeFile"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="closeDialogUpload">Cancelar</v-btn>
          <v-btn color="blue-darken-2" @click="uploadFile">
            Cargar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Permisos-->
    <v-dialog v-model="permissionsDialog" max-width="650">
      <v-card>
        <v-card-title class="bg-purple text-white">
          <v-icon start>mdi-account-lock</v-icon>
          Gestionar permisos
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="mb-4">
            Elemento: <strong>{{ permissionTargetName }}</strong>
          </p>

          <v-radio-group v-model="permissionMode">
            <v-radio label="Visible para todos" value="all" />
            <v-radio label="Usuarios específicos" value="custom" />
          </v-radio-group>

          <v-autocomplete
            v-if="permissionMode === 'custom'"
            v-model="selectedUsers"
            :items="usersOptions"
            item-title="label"
            item-value="value"
            label="Seleccionar clientes"
            multiple
            chips
            closable-chips
            variant="outlined"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="closePermissionsDialog">
            Cancelar
          </v-btn>
          <v-btn color="purple" @click="savePermissions">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Vista de Permisos -->
    <v-dialog v-model="viewPermissionsDialog" max-width="750">
      <v-card>
        <v-card-title class="bg-indigo text-white d-flex justify-space-between align-center">
          <div>
            <v-icon start>mdi-account-eye</v-icon>
            Permisos vigentes
          </div>

          <v-btn
            icon
            variant="text"
            color="white"
            @click="closeViewPermissionsDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <p class="mb-4">
            Elemento:
            <strong>{{ viewPermissionTargetName }}</strong>
          </p>

          <v-alert
            v-if="currentPermissionsError"
            type="error"
            variant="tonal"
            class="mb-3"
          >
            {{ currentPermissionsError }}
          </v-alert>

          <div class="d-flex justify-end mb-2">
            <v-btn
              size="small"
              variant="text"
              color="indigo"
              prepend-icon="mdi-refresh"
              @click="loadCurrentPermissions"
            >
              Actualizar
            </v-btn>
          </div>

          <v-data-table
            :headers="currentPermissionsHeaders"
            :items="currentPermissions"
            :loading="loadingCurrentPermissions"
            density="compact"
            no-data-text="No hay permisos vigentes para este elemento."
          >
            <template #item.tipo_permiso="{ item }">
              <v-chip
                :color="item.tipo_permiso === 'general' ? 'green' : 'blue'"
                size="small"
                variant="tonal"
              >
                {{ item.tipo_permiso === 'general' ? 'General' : 'Específico' }}
              </v-chip>
            </template>

            <template #item.actions="{ item }">
              <v-btn
                icon
                size="small"
                color="red"
                variant="text"
                title="Eliminar permiso"
                @click="deleteCurrentPermission(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="closeViewPermissionsDialog">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { computed, ref, onMounted } from "vue"
import { useStore } from "vuex"

const store = useStore()
const loading = ref(false)

const Folderdialog = ref(false)
const dialogUpload = ref(false)
const valid = ref(false)

const selectedFile = ref(null)
const selectedFolder = ref(null)

//Permisos
const permissionsDialog = ref(false)
const permissionTarget = ref(null)
const permissionTargetType = ref(null)
const permissionTargetName = ref("")
const permissionMode = ref("all")
const selectedUsers = ref([])

//Parametros para Visualizar Permisos
const viewPermissionsDialog = ref(false)
const viewPermissionTarget = ref(null)
const viewPermissionTargetType = ref(null)
const viewPermissionTargetName = ref("")
const currentPermissions = ref([])
const loadingCurrentPermissions = ref(false)
const currentPermissionsError = ref(null)

//Obtenemos los valores del Store
const files = computed(() => store.getters["files/getFiles"])
const folders = computed(() => store.state.files.folders || [])

const folderOptions = computed(() => [
  { label: "Sin carpeta (Raíz)", value: null },
  ...folders.value.map(folder => ({
    label: folder.folder_name,
    value: folder.id_folder
  }))
])

const usersOptions = computed(() => {
  const users = store.state.user.clients || []
  return users.map(usuario => ({
    label: usuario.mail,
    value: usuario.id_usuario
  }))
})

const formData = ref({
  folder_name: ''
})

const groupBy = ref([{ key: "grupo_carpeta", order: "asc" }])

const headers = [
  { title: "Nombre", key: "file_name" },
  { title: "Ruta", key: "file_content" },
  { title: "Vigente", key: "vigente" },
  { title: "Acciones", key: "actions", sortable: false },
]

//Header de la tabla de Permisos
const currentPermissionsHeaders = [
  { title: "Tipo", key: "tipo_permiso" },
  { title: "CUIT", key: "cuit" },
  { title: "Mail", key: "mail" },
  { title: "Acciones", key: "actions", sortable: false },
]

const API_BASE = process.env.VUE_APP_API_BASE;

const fetchFiles = async () => {
  loading.value = true
  await store.dispatch("files/fetchFiles")
  loading.value = false
}

const fetchFolders = async () => {
  await store.dispatch("files/fetchFolders")
}

const openFolderDialog = () => {
  formData.value = {
    folder_name: ''
  }
  Folderdialog.value = true
}

const closeDialog = () => {
  formData.value = {
    folder_name: ''
  }
  Folderdialog.value = false
}

const saveFolder = async () => {
  if (!valid.value) return
  loading.value = true
  const result = await store.dispatch("files/AddFolders", formData.value)
  if (result.success) {
    Folderdialog.value = false
  } else {
    alert(result.message || "Error al crear la Carpeta")
  }
  loading.value = false
}

const opendialogUpload = async () => {
  selectedFolder.value = null
  selectedFile.value = null
  await fetchFolders()
  dialogUpload.value = true
}

const closeDialogUpload = () => {
  selectedFolder.value = null
  selectedFile.value = null
  dialogUpload.value = false
}

const normalizeFile = (value) => {
  if (Array.isArray(value)) {
    selectedFile.value = value[0] || null
  } else {
    selectedFile.value = value
  }
}

const fileRule = (value) => {
  if (!value) return "Debes seleccionar un archivo"
  return true
}

const uploadFile = async () => {
  if (!selectedFile.value) {
    alert("Debes seleccionar un archivo")
    return
  }

  loading.value = true

  const res = await store.dispatch("files/uploadFile", {
    archivo: selectedFile.value,
    id_folder: selectedFolder.value
  })

  if (res.success) {
    alert("✅ Archivo subido correctamente.")
    closeDialogUpload()
  } else {
    alert(res.error || res.message || "❌ Error al subir el archivo.")
  }

  loading.value = false
}

const toggleVigente = async (item) => {
  const nuevoEstado = item.vigente ? 0 : 1
  await store.dispatch("files/toggleVigente", { id: item.id_file, vigente: nuevoEstado })
}

const deleteFile = async (id) => {
  if (confirm("¿Seguro que deseas eliminar este archivo?")) {
    await store.dispatch("files/deleteFile", id)
  }
}

const getFolderFromGroup = (groupItem) => folders.value.find(
  folder => folder.folder_name === groupItem.value
)

const canDeleteFolder = (groupItem) => {
  const folder = getFolderFromGroup(groupItem)
  return folder?.can_delete === true
}

const deleteFolder = async (groupItem) => {
  const folder = getFolderFromGroup(groupItem)

  if (!folder?.id_folder || folder.can_delete !== true) {
    alert("La carpeta no se puede eliminar porque contiene archivos.")
    return
  }

  if (!confirm(`¿Seguro que deseas eliminar la carpeta "${folder.folder_name}"?`)) return

  loading.value = true
  const result = await store.dispatch("files/deleteFolder", folder.id_folder)
  loading.value = false

  if (!result?.success) {
    alert(result?.error || result?.message || "No se pudo eliminar la carpeta.")
  }
}

const resolveFileUrl = (path) => {
  if (!path) return ""
  if (path.toLowerCase().startsWith("http")) return path
  return `${API_BASE}/${path}`
}

const getRawItem = (item) => item?.raw || item

const isFile = (item) => {
  const file = getRawItem(item)
  return file?.id_file !== null && file?.id_file !== undefined && file?.id_file !== ""
}

const countFiles = (items = []) => items.reduce((total, item) => {
  if (Array.isArray(item?.items)) return total + countFiles(item.items)
  return total + (isFile(item) ? 1 : 0)
}, 0)

const fileRowProps = ({ item }) => isFile(item)
  ? {}
  : { class: "empty-folder-placeholder" }

const openPermissionsDialog = (item, type) => {
  permissionTarget.value = item
  permissionTargetType.value = type
  permissionTargetName.value = item.file_name
  permissionMode.value = "all"
  selectedUsers.value = []
  permissionsDialog.value = true
}

const openFolderPermissions = (groupItem) => {
  const folder = getFolderFromGroup(groupItem)

  permissionTarget.value = folder
  permissionTargetType.value = "folder"
  permissionTargetName.value = groupItem.value
  permissionMode.value = "all"
  selectedUsers.value = []
  permissionsDialog.value = true
}

const closePermissionsDialog = () => {
  permissionsDialog.value = false
  selectedUsers.value = []
}

const savePermissions = async () => {
  const usuarios = permissionMode.value === "all"
    ? [0]
    : selectedUsers.value

  let result = null

  if (permissionTargetType.value === "folder") {
    if (!permissionTarget.value?.id_folder) {
      alert("No se pudo identificar la carpeta.")
      return
    }

    result = await store.dispatch("files/addPermisosFolder", {
      id_folder: permissionTarget.value.id_folder,
      usuarios
    })
  }

  if (permissionTargetType.value === "file") {
    result = await store.dispatch("files/addPermisosFile", {
      id_file: permissionTarget.value.id_file,
      usuarios
    })
  }

  if (result?.success) {
    alert("✅ Permisos guardados correctamente")
    closePermissionsDialog()
  } else {
    alert(result?.error || "Error al guardar permisos")
  }
}

//Abrir Modal de Permisos para Archivos
const openViewPermissionsDialog = async (item, type) => {
  viewPermissionTarget.value = item
  viewPermissionTargetType.value = type
  viewPermissionTargetName.value = item.file_name || "Archivo seleccionado"
  currentPermissions.value = []
  currentPermissionsError.value = null
  viewPermissionsDialog.value = true

  await loadCurrentPermissions()
}

//Abrir Modal de Permisos para Carpetas
const openViewFolderPermissions = async (groupItem) => {
  const folder = getFolderFromGroup(groupItem)

  if (!folder?.id_folder) {
    alert("No se pudo identificar la carpeta.")
    return
  }

  viewPermissionTarget.value = folder
  viewPermissionTargetType.value = "folder"
  viewPermissionTargetName.value = folder.folder_name
  currentPermissions.value = []
  currentPermissionsError.value = null
  viewPermissionsDialog.value = true

  await loadCurrentPermissions()
}

//Cerrar Modal de Permisos
const closeViewPermissionsDialog = () => {
  viewPermissionsDialog.value = false
  viewPermissionTarget.value = null
  viewPermissionTargetType.value = null
  viewPermissionTargetName.value = ""
  currentPermissions.value = []
  currentPermissionsError.value = null
}

//Cargar los permisos vigentes
const loadCurrentPermissions = async () => {
  if (!viewPermissionTarget.value || !viewPermissionTargetType.value) return

  loadingCurrentPermissions.value = true
  currentPermissionsError.value = null

  try {
    let result = null

    if (viewPermissionTargetType.value === "folder") {
      result = await store.dispatch("files/getPermisionFolder", {
        id_folder: viewPermissionTarget.value.id_folder
      })
    }

    if (viewPermissionTargetType.value === "file") {
      result = await store.dispatch("files/getPermisionFile", {
        id_file: viewPermissionTarget.value.id_file
      })
    }

    if (!result?.success) {
      currentPermissions.value = []
      currentPermissionsError.value = result?.error || "No se pudieron obtener los permisos."
      return
    }

    currentPermissions.value = result.data || []

  } catch (error) {
    console.error(error)
    currentPermissions.value = []
    currentPermissionsError.value = "Error al obtener permisos vigentes."
  } finally {
    loadingCurrentPermissions.value = false
  }
}

//Eliminar los permisos
const deleteCurrentPermission = async (item) => {
  const message = item.tipo_permiso === "general"
    ? "Este permiso permite que todos los usuarios vean este elemento. ¿Seguro que querés eliminarlo?"
    : "¿Seguro que querés eliminar este permiso específico?"

  if (!confirm(message)) return

  try {
    let result = null

    if (viewPermissionTargetType.value === "folder") {
      result = await store.dispatch("files/deletePermisionFolder", {
        id_permisos_folder: item.id_permisos_folder
      })
    }

    if (viewPermissionTargetType.value === "file") {
      result = await store.dispatch("files/deletePermisionFile", {
        id_permisos_file: item.id_permisos_file
      })
    }

    if (!result?.success) {
      currentPermissionsError.value = result?.error || "No se pudo eliminar el permiso."
      return
    }

    await loadCurrentPermissions()

  } catch (error) {
    console.error(error)
    currentPermissionsError.value = "Error al eliminar el permiso."
  }
}

onMounted(async() => {
  await Promise.all([fetchFiles(), fetchFolders()])
  await store.dispatch("user/fetchClients")
})
</script>

<style scoped>
:deep(.empty-folder-placeholder) {
  display: none;
}
</style>
